import { useQuery } from '@apollo/client';
import { graphql } from '../gql';
import { useMemo } from 'react';
import {
  getPaginatedNodes,
  getPaginationTotalResults,
  toPagination,
} from './utils';
import { PaginationSort, PortFilterInput } from '../gql/graphql';

export const GET_PORT_LIST = graphql(`
  query getPortList(
    $pagination: PaginationRequest
    $filters: PortFilterInput
    $sort: PaginationSort
  ) {
    ports(pagination: $pagination, filters: $filters, sort: $sort) {
      edges {
        node {
          uuid
          port
          protocol
          source
          createdAt
          updatedAt
        }
      }
      pageInfo {
        totalResults
        hasNextPage
        hasPreviousPage
        pageNumber
        pageSize
      }
    }
  }
`);
export interface IUsePortListQueryArg {
  pageNumber: number;
  pageSize: number;
  sort?: PaginationSort;
  filters?: PortFilterInput;
}
export function usePortListQuery({
  pageNumber,
  pageSize,
  sort,
  filters,
}: IUsePortListQueryArg) {
  const { loading, data, error } = useQuery(GET_PORT_LIST, {
    variables: {
      pagination: toPagination(pageNumber, pageSize),
      sort,
      filters: {
        ...filters,
      },
    },
  });
  const { ports, totalPorts } = useMemo(() => {
    if (loading) {
      return {
        ports: [],
        totalPorts: 0,
      };
    }
    return {
      ipAddresses: getPaginatedNodes(data?.ports),
      totalIpAddresses: getPaginationTotalResults(data?.ports) ?? 0,
    };
  }, [data, loading]);

  return {
    loading,
    error,
    data,
    ports,
    totalPorts,
  };
}
